module.exports = __webpack_public_path__ + "static/img/Deep learning.12b0aaf.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/mobile/technology/Deep learning.jpg
// module id = 2N26
// module chunks = 1